import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  //   fonts: {
  //     body: 'Inter',
  //   },
});

export default theme;
